module.exports = __webpack_public_path__ + "img/forest-white.0c85090b.svg";